import { render, staticRenderFns } from "./RiskAssessmentFirst.vue?vue&type=template&id=64fead62&scoped=true"
import script from "./RiskAssessmentFirst.vue?vue&type=script&lang=js"
export * from "./RiskAssessmentFirst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fead62",
  null
  
)

export default component.exports